<template>
  <div>
    <v-select :filterable="false" @search="fetchOptions" v-model="selectedValue" :options="options"
      :dir="$vs.rtl ? 'rtl' : 'ltr'" /><br>
  </div>
</template>
<script>
import vSelect from 'vue-select'
import { axiosMixin } from "@/mixin/axiosMixin.js";
import { mapGetters } from "vuex";
export default {
  mixins: [axiosMixin],
  components: {
    'v-select': vSelect,
  },
  props: {
    masterStockCode: {
      type: Number,
      default: null,
    }
  },
  data() {
    return {
      selectedValue: null,
      options: [
      ],
    };
  },

  computed: {
    ...mapGetters({
      getGr: "main/getGr",
    })
  },
  mounted() {
    this.getSubStockCode();
    this.selectedValue = this.getGr.subStockCode;
  },
  computed: {
    ...mapGetters({
      getGr: "main/getGr",
    })
  },
  methods: {
    fetchOptions(search, loading) {
      loading(true)
      // fetch data from server
      var params = "page1&per_page=10";
      var sort = "&sort_by=id&sort_direction=asc";
      this.selectedValue = null;
      this.aronPost("getSubStockCode", { masterStockCode: masterStockCode, subStockCode: search, }, params, sort)
        .then(response => {
          console.log("date", response.data);
          if (response.status == 200) {
            this.options = response.data.subStockCode;
          }

          loading(false)
        })
        .catch(error => {
          // this.decodeErrorFromAxios(error);
          loading(false)
        });
    },
    getSubStockCode() {
      if (this.masterStockCode) {
        var params = "page1&per_page=10";
        var sort = "&sort_by=id&sort_direction=asc"
        this.aronPost("getSubStockCode", { masterStockCode: this.masterStockCode, subStockCode: "all", }, params, sort)
          .then(response => {
            console.log("date", response.data);
            if (response.status == 200) {
              this.options = response.data.subStockCode;

            }

          })
          .catch(error => {
            // this.decodeErrorFromAxios(error);
          });
      }
    }
  },
  watch: {
    selectedValue(value) {
      this.$emit('input', value);

      var params = "page1&per_page=10";
      var sort = "&sort_by=id&sort_direction=asc"

      this.aronPost("getSubStockCodeInfo", { masterStockCode: this.masterStockCode, subStockCode: value }, params, sort)
        .then(response => {
          console.log("date", response.data);
          if (response.status == 200) {
            this.$store.state.main.inventoryData = response.data.data;
            this.getGr.stockBalance = response.data.stockBalance;
          }

        })
        .catch(error => {
          // this.decodeErrorFromAxios(error);
        });
    },
  },
};
</script>
